import { Button } from "@/components/ui/button";
import { ApplicationItem } from "@/types/admin_types";
import { Check, X } from "lucide-react";
import { useState } from "react";
import DialogComponent from "../../_components/DialogComponent";
import ApplicationUpdateURL from "./ApplicationUpdateURL";

type Props = {
  el: ApplicationItem;
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default function UpdateApplicationStatus({el, open, setOpen}: Props) {

  const [ newStatus, setNewStatus ] = useState('')
  const handleUpdate = (value: string) => {
    setOpen(true)
    setNewStatus(value)
  }

  return (
    <div>
      <div className="flex gap-2">
        {!el?.status ?  (
          <>
            <Button
              variant="ghost"
              className="p-2 border"
              onClick={() => handleUpdate('approved')}
            >
              <Check strokeWidth={3} size={18} className="text-[#397930]"/>
            </Button>
            <Button
              variant="ghost"
              className="p-2 border"
              onClick={() => handleUpdate('rejected')}
            >
              <X strokeWidth={3} size={18} className="text-[#781417]"/>
            </Button>
          </>
        ) : null}
      </div>

      <DialogComponent
        open={open}
        setOpen={setOpen}
        title={newStatus === "approved" ? "Accepting Application" : "Rejecting Application"}
        subtitle={"subtitle"}
        components={
          <ApplicationUpdateURL el={el} newStatus={newStatus} setOpen={setOpen}/>
        }
      />
    </div>
  )
}
